"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOS = exports.getBrowser = void 0;
var isBrowser = function () { return typeof window !== "undefined"; };
function getBrowser() {
    if (!isBrowser())
        return '';
    var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isFirefox = typeof window.InstallTrigger !== 'undefined'; // Firefox 1.0+
    var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
    var isChrome = !!window.chrome && !isOpera; // Chrome 1+
    var isIE = /* @cc_on!@ */ false || !!document.documentMode; // IE6
    var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
    if (isOpera)
        return 'Opera';
    if (isFirefox)
        return 'Firefox';
    if (isIE)
        return 'Edge';
    if (isEdgeChromium)
        return 'EdgeChromium';
    if (isChrome)
        return 'Chrome';
    if (isSafari)
        return 'Safari';
    return '';
}
exports.getBrowser = getBrowser;
function getOS() {
    if (!isBrowser())
        return '';
    if (window.navigator.userAgent.indexOf('Windows') !== -1)
        return 'Windows';
    if (window.navigator.userAgent.indexOf('Mac') !== -1)
        return 'Mac/iOS';
    if (window.navigator.userAgent.indexOf('X11') !== -1)
        return 'UNIX';
    if (window.navigator.userAgent.indexOf('Linux') !== -1)
        return 'Linux';
    return '';
}
exports.getOS = getOS;
